module.exports = __webpack_public_path__ + "img/電気回路_3_3_2.acd82827.png";